import React from "react";
import { Seo } from "../seo/Seo";
import "./PrivacyPolicy.css";

export const PrivacyPolicy = () => (
  <main className="privacy-policy">
    <Seo
      title="Privacy Policy — Valere Kissi"
      description="Privacy policy for the Valere Kissi portfolio website and Instagram integration."
      path="/privacy-policy"
      noindex
    />

    <h1>Privacy Policy</h1>
    <p className="privacy-policy__updated">Last updated: July 29, 2026</p>

    <p>
      Valere Kissi (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) operates
      valerekissi.com. This policy explains how information is handled when you
      use this website or authorize its Instagram integration.
    </p>

    <h2>Information we collect</h2>
    <ul>
      <li>
        <strong>Contact form information:</strong> your name, email address, and
        message when you choose to contact us.
      </li>
      <li>
        <strong>Usage data:</strong> Google Analytics may collect information
        such as pages viewed, device/browser information, and approximate
        location through cookies or similar technologies.
      </li>
      <li>
        <strong>Instagram data:</strong> if the Instagram integration is
        enabled and authorized by the account owner, we access only the media
        data needed to display that account&apos;s public content, such as media
        URLs, thumbnails, captions, timestamps, media type, and post links.
      </li>
    </ul>

    <h2>How we use information</h2>
    <p>
      We use contact-form information to respond to enquiries, analytics to
      understand and improve the website, and Instagram media data solely to
      display the authorized account&apos;s posts and Reels on this website. We do
      not sell personal information or use Instagram data for advertising.
    </p>

    <h2>Sharing and service providers</h2>
    <p>
      We use service providers to operate the website, including Netlify for
      hosting, EmailJS for contact-form delivery, Google Analytics for website
      analytics, and Meta/Instagram for the Instagram integration. These
      providers process information according to their own terms and privacy
      policies.
    </p>

    <h2>Data retention and security</h2>
    <p>
      Contact messages are retained only as long as reasonably necessary to
      respond to and manage enquiries. Instagram access credentials are stored
      securely and are not displayed to website visitors. We use reasonable
      safeguards, but no internet transmission or storage system is completely
      secure.
    </p>

    <h2>Your choices and data deletion</h2>
    <p>
      You may request access to, correction of, or deletion of personal
      information we hold about you. An Instagram account owner may revoke this
      website&apos;s Instagram authorization at any time through Meta or Instagram
      settings. To make a privacy or data-deletion request, contact us at{" "}
      <a href="mailto:valerekissi69@gmail.com">valerekissi69@gmail.com</a>.
    </p>

    <h2>Changes to this policy</h2>
    <p>
      We may update this policy from time to time. The current version will
      always be available at this URL and will show its most recent update date.
    </p>

    <h2>Contact</h2>
    <p>
      For questions about this policy, contact Valere Kissi at{" "}
      <a href="mailto:valerekissi69@gmail.com">valerekissi69@gmail.com</a>.
    </p>
  </main>
);
